var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _rect7, _rect8, _rect9, _path3, _line, _line2, _circle, _circle2, _circle3, _path4, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _path5, _rect10, _rect11, _rect12, _rect13, _line16, _line17, _path6, _path7, _rect14, _rect15, _polygon, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationCorailHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    viewBox: "0 0 454.15317 400.49997",
    width: 454.15317,
    height: 400.49997,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-9, .cls-12 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-10, .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #224897;\n      }\n\n      .cls-2 {\n        stroke: #ce9d36;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 4.5px;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: #824837;\n      }\n\n      .cls-15, .cls-16 {\n        fill: #ce9d38;\n      }\n\n      .cls-17, .cls-18 {\n        fill: #224798;\n      }\n\n      .cls-19 {\n        fill: #224897;\n      }\n\n      .cls-20 {\n        fill: #1d1d1b;\n      }\n\n      .cls-21, .cls-6, .cls-22 {\n        fill: #608eca;\n      }\n\n      .cls-4, .cls-5, .cls-8 {\n        fill: #f4e5cc;\n        stroke: #e2cfb5;\n      }\n\n      .cls-4, .cls-8 {\n        stroke-width: .4px;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        stroke-width: .8px;\n      }\n\n      .cls-6 {\n        stroke: #406fa1;\n      }\n\n      .cls-7 {\n        fill: #010102;\n        stroke: #010102;\n      }\n\n      .cls-9 {\n        fill: #88b3e0;\n        opacity: .73;\n        stroke: #7eaad6;\n        stroke-width: .36px;\n      }\n\n      .cls-10 {\n        stroke-width: 1.44px;\n      }\n\n      .cls-10, .cls-11 {\n        stroke: #224798;\n      }\n\n      .cls-11 {\n        stroke-width: 1.56px;\n      }\n\n      .cls-22, .cls-18, .cls-16 {\n        opacity: .7;\n      }\n\n      .cls-12 {\n        stroke: #1d1d1b;\n        stroke-width: 1.44px;\n      }\n\n      .cls-23 {\n        fill: #9bb5df;\n        opacity: .65;\n      }\n      "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M 15.783163,50.14 H 351.83317 c 0,0 3.86,-26.66 -56.92,-26.66 -53.96,0 -211.950007,1.03 -245.980007,1.06 -6.98,0 -15.64,0.48 -21.73,3.9 -6.61,3.71 -11.79,12.25 -11.42,21.7 z",
    id: "path6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -170.37317,
    y: -71.050003,
    width: 117.38,
    height: 6.6700001,
    rx: 1.5700001,
    ry: 1.5700001,
    transform: "scale(-1)",
    id: "rect8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -139.85316,
    y: -86.880005,
    width: 86.860001,
    height: 3.75,
    rx: 0.74000001,
    ry: 0.74000001,
    transform: "scale(-1)",
    id: "rect10"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -117.40316,
    y: -93.729996,
    width: 64.410004,
    height: 3.75,
    rx: 0.74000001,
    ry: 0.74000001,
    transform: "scale(-1)",
    id: "rect12"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -132.49316,
    y: -100.57,
    width: 79.489998,
    height: 3.75,
    rx: 0.74000001,
    ry: 0.74000001,
    transform: "scale(-1)",
    id: "rect14"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -129.10316,
    y: -107.41,
    width: 76.110001,
    height: 3.5699999,
    rx: 0.74000001,
    ry: 0.74000001,
    transform: "scale(-1)",
    id: "rect16"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -102.48316,
    y: -114.74999,
    width: 49.490002,
    height: 3.75,
    rx: 0.74000001,
    ry: 0.74000001,
    transform: "scale(-1)",
    id: "rect18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m 328.12317,139.54 h -113.64 c -12.27,0 -12.27,10.77 -12.27,24.05 v 0 c 0,0 -0.67,-7.09 -0.67,-7.09 h 137.25 l 0.43,7.09 c 0,-13.28 -0.39,-22.51 -11.1,-24.05 z",
    id: "path20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 202.10316,
    y: 166.64001,
    width: 136.13,
    height: 7.75,
    id: "rect22"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 202.10316,
    y: 182.3,
    width: 136.13,
    height: 7.75,
    id: "rect24"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 202.19318,
    y: 197.93001,
    width: 136.13,
    height: 7.75,
    id: "rect26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m 335.80317,217.01 c -5.23,5.27 -5.54,5.48 -9.8,5.43 l -111.73,-0.1 c -4.28,0 -10.98,-3.22 -10.98,-7.5 h 133.76 z",
    id: "path28"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 296.28317,
    y1: 48.830002,
    x2: 350.46317,
    y2: 48.830002,
    id: "line30"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.193165,
    y1: 48.830002,
    x2: 240.65317,
    y2: 48.830002,
    id: "line32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 37.363167,
    cy: 37.220001,
    r: 4.8899999,
    id: "circle34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 51.803165,
    cy: 37.220001,
    r: 4.8899999,
    id: "circle36"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 66.033157,
    cy: 37.220001,
    r: 4.8899999,
    id: "circle38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m 326.12317,222.45 -113.38,-0.2 c -8.67,0 -10.56,-10.51 -10.56,-17.7 v -52 c 0,-7.18 4.92,-13.01 10.99,-13.01 h 114.67 c 6.07,0 10.99,5.82 10.99,13.01 v 52 c 0,7.18 -4.12,17.9 -12.71,17.9 z",
    id: "path40"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 202.19318,
    y1: 165.81001,
    x2: 338.83316,
    y2: 165.81001,
    id: "line42"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 270.51318,
    y1: 222.28001,
    x2: 270.51318,
    y2: 156.05,
    id: "line44"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 246.09317,
    y1: 222.28001,
    x2: 246.09317,
    y2: 156.05,
    id: "line46"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 224.22318,
    y1: 222.28001,
    x2: 224.22318,
    y2: 156.05,
    id: "line48"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 316.73315,
    y1: 222.28001,
    x2: 316.73315,
    y2: 156.50002,
    id: "line50"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 294.86316,
    y1: 222.28001,
    x2: 294.86316,
    y2: 156.05,
    id: "line52"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 202.19318,
    y1: 174.39001,
    x2: 339.43317,
    y2: 174.39001,
    id: "line54"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 201.54317,
    y1: 156.50002,
    x2: 338.79318,
    y2: 156.50002,
    id: "line56"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 202.19318,
    y1: 181.99001,
    x2: 339.43317,
    y2: 181.99001,
    id: "line58"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 202.10316,
    y1: 189.3,
    x2: 339.35318,
    y2: 189.3,
    id: "line60"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 201.89317,
    y1: 197.93001,
    x2: 339.13318,
    y2: 197.93001,
    id: "line62"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 201.89317,
    y1: 205.68001,
    x2: 339.13318,
    y2: 205.68001,
    id: "line64"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 202.39317,
    y1: 214.13,
    x2: 337.04318,
    y2: 214.13,
    id: "line66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 347.41317,39.49 c 3.99,5.19 4.27,8.6 4.27,15.65 v 155.55 c 0,16.98 -13.77,30.75 -30.75,30.75 H 45.583163 c -16.98,0 -30.75,-13.77 -30.75,-30.75 V 55.13 c 0,-16.98 6.79,-30.75 30.75,-30.75 H 297.03317",
    id: "path68"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 262.19318,
    y: 352.22,
    width: 64.940002,
    height: 47.419998,
    id: "rect70"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 174.56317,
    y: 317.16998,
    width: 69.07,
    height: 82.470001,
    id: "rect72"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 86.943153,
    y: 255.32001,
    width: 69.07,
    height: 144.32001,
    id: "rect74"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 6.5431652,
    y: 295.91998,
    width: 62.880001,
    height: 103.71,
    id: "rect76"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 25.703167,
    y1: 136.59001,
    x2: 25.703167,
    y2: 222.45001,
    id: "line78"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 183.25317,
    y1: 222.45001,
    x2: 25.703167,
    y2: 222.45001,
    id: "line80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 30.043163,198.83 c 7.69,-19.77 17.83,-27.73 25.34,-31.4 7.14,-3.49 18.2,-3.99 40.320004,-5 21.750003,-0.99 28.260003,0.25 37.830003,-5 7.79,-4.27 8.37,-7.78 16.77,-12.49 10.87,-6.09 22.03,-7.01 29.98,-6.78",
    id: "path82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m 26.113163,199.54 c 12.27,-3.49 21.03,-2.38 26.76,-0.71 6.52,1.89 8.88,4.42 15.34,4.64 3.66,0.12 7.11,-0.55 19.27,-6.07 18.220007,-8.27 19.180007,-10.72 24.980007,-10.71 10.41,0.03 11.39,7.93 19.63,7.49 10.47,-0.56 13.87,-13.6 32.47,-33.19 6.04,-6.36 11.52,-11.14 15.34,-14.27",
    id: "path84"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 181.87317,
    y: 220.54001,
    width: 3.48,
    height: 3.48,
    rx: 1.16,
    ry: 1.16,
    id: "rect86"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 343.41318,
    y: 293.19998,
    width: 69.07,
    height: 107.3,
    id: "rect88"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.47,155.29 48.08,169.16 46.16,170.42 46.33,157.06 ",
    id: "polygon90",
    transform: "translate(-15.376836,-22.32)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m 19.383163,154.13 0.75,-3.97 7.84,-2.37 0.64,3.74 -0.15,3.09 c 0,0 -6.33,-2.92 -9.08,-0.48 z",
    id: "path92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m 2.7531645,185.46 c 0,0 0.419999,10.32 7.4099985,9.14 l -1.2199998,-8.59 c 0,0 -2.8499997,1.33 -6.1899987,-0.55 z",
    id: "path94"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m 55.383163,177.23 c 0,0 21.35,4.26 27.84,-2.13 0,0 2.81,-3.04 5.17,-3.4 2.36,-0.36 3.510004,-2.1 3.510004,-2.1 0,0 3.43,-2.12 -1.330004,2.6 0,0 4.310004,7.39 -4.67,5.44 0,0 -20.65,13.15 -35.17,7.68 0,0 5.06,-4.61 4.65,-8.09 z",
    id: "path96"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m 23.893163,236.21 c -0.83,2.76 -1.94,6.98 -2.73,12.22 -0.53,3.55 -0.51,4.88 -0.88,9.06 -0.88,9.91 -1.88,12.1 -3.25,23.83 -0.28,2.39 -0.69,6.14 -1.06,10.82 0.73,-0.05 1.83,-0.08 3.17,0 2.77,0.17 4.83,0.31 6.07,1.76 0.33,0.38 0.81,1.11 0.97,2.37 H 7.8831632 c 0.35,-0.76 0.69,-1.64 0.97,-2.64 0.15,-0.52 0.26,-1.02 0.35,-1.5 -0.62,-0.06 -1.23,-0.12 -1.85,-0.18 0.93,-8.42 0.91,-15.09 0.7,-19.7 -0.21,-4.66 -0.74,-10.32 0.79,-17.85 0.46,-2.27 0.7,-2.71 1.14,-4.84 1.6299998,-7.88 0.7199998,-14.2 0.4399998,-16.8 -0.5699998,-5.32 -0.8999998,-13.52 0.31,-25.85 3.47,0.16 7.16,0.21 11.05,0.11 5.38,-0.14 10.39,-0.54 14.99,-1.09 -0.04,3.01 -0.07,7.57 0.11,13.13 0.43,13.64 1.73,23.59 2.19,27.46 1.13,9.45 2.17,23.71 1.53,44.09 0.74,0.7 1.79,1.47 3.17,1.86 2.04,0.57 2.94,-0.21 5.47,0.44 1.12,0.28 2.68,0.71 3.17,1.97 0.26,0.66 0.13,1.31 0,1.75 h -18.71 c -0.21,-0.54 -0.49,-1.51 -0.44,-2.74 0.05,-1.19 0.41,-2.1 0.66,-2.63 -0.66,0.04 -1.31,0.07 -1.97,0.11 -0.38,-6.44 -1.01,-11.64 -1.53,-15.21 -1.46,-10.09 -2.82,-13.25 -2.52,-19.36 0.06,-1.24 0.22,-3.22 -0.22,-5.91 -0.49,-2.94 -1.29,-4.24 -2.3,-7.66 -0.48,-1.62 -1.09,-4.01 -1.51,-7.04 z",
    id: "path98"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m 19.383163,154.13 c 3.25,-1.67 6.72,-0.95 8.13,-0.17 0.53,0.29 0.95,0.65 0.95,0.65 0.91,0.79 1.22,1.61 1.58,2.2 0.54,0.88 1.23,1.29 2.81,2.2 3.94,2.26 6.33,3.53 7.74,4.4 1.69,1.04 2.15,1.61 5.8,4.92 2.13,1.93 5.22,4.69 9.15,8 -0.19,1.16 -0.54,2.56 -1.23,4.05 -1.8,3.91 -4.79,6.08 -6.33,7.04 -2.18,-1.17 -4.53,-2.59 -6.95,-4.31 -1.36,-0.97 -2.62,-1.94 -3.78,-2.9 -0.59,4.21 0.68,8.17 0.49,13.2 -0.18,4.57 -0.21,10.09 0,14.01 -2.83,0.41 -7.11,0.14 -9.55,0.32 -4.2,0.32 -6.78,0.51 -10.11,0.18 -2.28,-0.23 -4.89,-0.69 -7.74,-1.58 0.17,-3.1 0.19,-6.61 -0.09,-10.47 -0.2599998,-3.64 -0.7499998,-6.94 -1.3199998,-9.85 -0.95,0.22 -3.0499997,0.57 -5.4499997,-0.26 -0.26,-0.09 -0.5,-0.19 -0.739999,-0.29 -1.04,-0.46 -1.82000016,-1.02 -2.34000016,-1.47 0.1,-5.8 0.90999996,-10.46 1.67000016,-13.72 1.049999,-4.48 2.139999,-6.84 4.2199987,-8.35 0.43,-0.31 1.34,-0.77 3.17,-1.67 3.7199998,-1.85 4.5199998,-1.87 6.3299998,-3.08 2.46,-1.64 1.73,-2.08 3.58,-3.03 z",
    id: "path100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m 16.633163,156.56 2.16,0.31 c 1.74,0.25 3.52,0.26 5.26,0.01 l 5.64,-0.69",
    id: "path102"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m 20.063163,151.58 c 0,0 -6.22,-8 -6.4,-13.36 -0.18,-5.36 4,-7.82 4,-7.82 0,0 2.25,-1.66 5.15,-1.29 2.9,0.37 9.18,-4.03 9.18,-4.03 0,0 1.67,-1.5 0.62,2.25 0,0 4.55,-4.86 3.02,3.26 0,0 6.46,-3.69 -3.2,4.86 0,0 -0.18,-0.49 -0.49,2.15 -0.31,2.64 -0.37,9.36 -0.37,9.36 0,0 3.94,-7.77 0.68,3.47 0,0 -0.93,1.67 -2.83,1.74 -0.8,0.03 -1.5,-0.52 -1.69,-1.3 l -0.52,-2.19 -2.08,2.26 c -0.48,0.52 -1.15,0.8 -1.86,0.77 l -3.2,-0.14 z",
    id: "path104"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m 28.853163,144.54 c 0.07,-0.28 0.13,-0.69 0,-1.12 -0.22,-0.74 -0.77,-0.82 -1.05,-1.46 -0.35,-0.79 -0.1,-2.05 0.66,-2.41 0.53,-0.25 1.23,-0.02 1.65,0.34 0.98,0.84 0.77,2.67 0.1,3.75 -0.45,0.73 -1.27,1.35 -1.41,1.24 -0.06,-0.04 0,-0.21 0.05,-0.34 z",
    id: "path106"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m 378.93317,56.17 c 0.14,0.22 -0.27,0.87 -0.84,0.98 -0.44,0.08 -0.85,-0.18 -1.19,-0.42 -1.84,-1.28 -2.69,-2.48 -2.97,-2.36 -0.24,0.11 0.05,1.12 0.24,1.73 1.57,5.23 2.54,6.32 3.04,6.82 0.53,0.52 1.34,1.33 2.08,1.18 0.87,-0.18 1.1,-1.58 1.74,-1.49 0.37,0.05 0.4,0.51 1,0.85 0.43,0.24 0.87,0.26 1.45,0.22 2.25,-0.15 2.92,-0.84 3.85,-0.46 0.6,0.24 0.46,0.57 1.18,1.17 1.97,1.64 5.3,1.11 5.97,1 0.91,-0.15 1.38,-0.35 2.26,-0.2 0.78,0.14 1.1,0.43 2.16,0.98 1.72,0.91 2.74,1.45 4.03,1.56 1.26,0.11 1.71,-0.28 2.68,0.16 0.73,0.33 0.67,0.63 1.45,1.06 0.95,0.53 1.86,0.52 3.2,0.51 1.19,0 1.91,-0.01 2.77,-0.36 0.86,-0.35 1.18,-0.77 1.83,-0.65 0.71,0.13 0.88,0.73 1.41,0.69 0.63,-0.05 0.99,-0.95 1.14,-1.32 0.33,-0.83 0.14,-1.2 0.33,-1.75 0.18,-0.54 0.72,-1.23 2.38,-1.71 -0.64,0.21 -1.29,0.15 -1.64,-0.21 -0.51,-0.51 -0.26,-1.46 0.07,-1.98 0.78,-1.25 2.27,-0.53 3.39,-1.61 1.38,-1.32 0.06,-3.28 1.43,-4.3 0.87,-0.64 1.63,-0.04 3.48,-0.86 0.51,-0.23 1.04,-0.4 1.55,-0.63 0.65,-0.3 0.89,-0.46 1.24,-0.39 0.63,0.13 0.91,0.82 1.08,0.75 0.18,-0.08 -0.31,-0.81 -0.12,-1.55 0.27,-1.07 1.76,-1.2 1.69,-1.96 -0.03,-0.33 -0.31,-0.34 -0.37,-0.74 -0.08,-0.6 0.55,-0.79 0.69,-1.54 0.11,-0.57 -0.15,-1.08 -0.29,-1.35 -0.04,-0.08 -0.68,-1.29 -1.63,-1.38 -0.56,-0.05 -0.8,0.32 -1.36,0.63 -1.36,0.74 -3.06,0.25 -5.08,-0.33 -1.31,-0.38 -2.3,-0.85 -2.84,-1.14 -1.83,-0.96 -3.15,-2.14 -3.46,-2.43 -1.03,-0.94 -1.7,-1.8 -2.32,-1.63 -0.34,0.09 -0.34,0.4 -0.75,0.55 -0.49,0.18 -0.96,-0.07 -1.97,-0.57 -2.4,-1.18 -2.65,-1.18 -2.94,-1.65 -0.41,-0.66 -0.42,-1.47 -0.64,-1.48 -0.16,0 -0.21,0.41 -0.34,0.39 -0.17,-0.02 -0.28,-0.78 -0.31,-1.54 -0.04,-0.79 0.02,-1.33 0.05,-1.74 0.06,-0.87 0.12,-1.73 0,-2.54 -0.2,-1.37 -0.88,-2.37 -1.56,-3.36 -0.66,-0.97 -0.99,-1.46 -1.66,-1.93 -0.56,-0.41 -0.95,-0.51 -1.25,-1 -0.36,-0.61 -0.08,-0.95 -0.31,-1.58 -0.29,-0.79 -0.95,-0.76 -2.17,-1.72 -1.25,-0.99 -0.99,-1.36 -2.43,-2.54 -0.95,-0.78 -1,-0.57 -1.82,-1.31 -1.06,-0.96 -1.47,-1.759999 -1.96,-1.67 -0.4,0.07 -0.32,0.66 -0.85,0.83 -0.19,0.06 -0.4,0.05 -1.56,-0.43 -1.16,-0.47 -1.11,-0.519999 -1.33,-0.539999 -0.76,-0.05 -0.94,0.529999 -1.92,0.819999 -0.45,0.13 -0.92,0.11 -1.84,0.05 -1.41,-0.08 -2.11,-0.13 -2.77,-0.44 -1.37,-0.649999 -1.57,-1.749999 -2.41,-1.749999 -0.15,0 -0.59,0.04 -1.27,0.95 -1.15,1.549999 -0.87,2.779999 -1.8,5.879999 -0.32,1.07 -0.56,1.61 -0.87,2.13 -0.63,1.04 -1.3,1.58 -1.7,1.97 -1.24,1.22 -1.55,2.77 -1.96,4.79 -0.77,3.86 0.06,7.74 0.17,8.21 0.27,1.21 0.66,2.42 0.26,3.93 -0.29,1.11 -0.87,1.91 -1.31,2.41 0.28,-0.04 0.71,-0.06 1.22,0.08 0.58,0.16 1.22,0.52 1.19,0.71 -0.04,0.19 -0.75,-0.05 -1.45,0.26 -0.81,0.36 -1.11,1.23 -1.18,1.44 -0.4,1.15 0.14,2.24 0.84,3.71 0.66,1.37 1.42,2.94 2.63,3.13 0.63,0.1 1.14,-0.22 1.27,-0.01 z",
    id: "path108"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(-15.376836,-22.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m 424.78,207.33 c -3.62,-0.2 -5.84,2.25 -6.16,2.62 -2.17,-4.24 -4.33,-8.48 -6.5,-12.73 -0.37,-0.37 -0.93,-0.88 -1.65,-1.43 -1.52,-1.15 -3.02,-2.29 -4.98,-2.46 -0.28,-0.02 -3.04,-0.23 -4.08,1.36 -0.56,0.86 -0.16,1.54 -0.22,3.45 -0.02,0.7 -0.09,3.06 -1.15,4.98 -0.29,0.52 -1.83,3.32 -5.18,3.73 -3.35,0.41 -5.88,-1.88 -6.2,-2.18 0.3,0.87 0.6,1.75 0.89,2.62 -2.23,0.98 -4.46,1.96 -6.69,2.93 0.75,1.54 1.49,3.07 2.24,4.61 l -6.41,2.81 c -0.48,-0.37 -1.17,-0.92 -1.94,-1.65 -0.87,-0.82 -1.21,-1.27 -1.44,-1.17 -0.31,0.12 -0.3,1.17 0.16,2 0.66,1.2 2.22,1.86 2.43,1.95 0.45,0.19 0.93,0.31 1.33,0.79 0.28,0.33 0.4,0.69 0.43,0.85 0.17,0.89 -1.31,2.1 -3.65,2.89 3.07,2.21 6.14,4.42 9.21,6.63 0.1,-0.63 0.44,-2.18 1.69,-2.72 0.65,-0.28 1.3,-0.18 1.64,-0.12 4.07,0.73 7.33,2.86 8.19,2.09 0.97,-0.87 -1.28,-5.22 -1.3,-5.28 v 0 c -6.41,1.04 -7.79,0.23 -7.79,0.23 -0.79,-0.46 -1.81,-1.42 -2.44,-3.66 2.14,-0.99 4.27,-1.99 6.41,-2.98 2.98,1.42 5.96,2.83 8.95,4.25 4.69,-2.11 9.38,-4.23 14.07,-6.34 0.45,0.99 1.29,2.47 2.79,3.85 2.91,2.68 6.29,3.11 7.4,3.21 -0.89,-0.67 -1.2,-1.73 -0.82,-2.48 0.23,-0.45 0.76,-0.91 1.36,-0.85 0.94,0.09 1.19,1.39 1.93,1.48 0.71,0.08 1.4,-1.02 2.04,-2.53 1.61,-3.78 2.42,-5.69 1.34,-7.64 -1.55,-2.8 -5.54,-3.07 -5.9,-3.09 z",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m 399.03,190.65 c 0.72,-1.66 1.44,-3.33 2.16,-4.99 -2.18,0.07 -4.36,0.13 -6.53,0.2 -0.44,1.43 -0.89,2.86 -1.33,4.28 1.9,0.17 3.8,0.34 5.7,0.51 z",
    id: "path112"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(-15.376836,-22.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m 348.68,62.58 -6.15,1.25 c -0.51,0.1 -1.03,0.15 -1.56,0.15 -1.06,0 -2.11,-0.21 -3.11,-0.62 l -4.29,-1.76 c -0.17,-0.07 -0.33,-0.13 -0.51,-0.18 l -6.76,-1.98 c -0.95,-0.28 -1.8,-0.82 -2.46,-1.56 l -2.64,-3 -5.92,-5.71 4.94,-9.02 -0.64,-5.94 3.02,-1.61 c 0.46,-0.24 0.97,-0.37 1.5,-0.37 0.58,0 1.16,0.15 1.67,0.44 l 1.84,1.05 4.55,-2.52 2.69,-2.54 1.12,-0.09 1.63,-2.98 0.2,-0.16 c 1.62,-1.25 3.67,-1.89 6.08,-1.89 4.2,0 8.11,1.95 8.27,2.03 l 12.16,5.57 2.03,5.86 5.66,2.32 -3.35,6.12 2.66,4.41 -2.54,4.64 -7.57,1.72 -1.64,4.51 -4.78,0.95 -1.82,3.33 -4.27,-2.44 z",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m 343.87,24.79 c 3.96,0 7.72,1.9 7.72,1.9 l 11.72,5.37 2.04,5.89 4.9,2.01 -3.03,5.54 2.66,4.41 -1.93,3.53 -7.68,1.74 -1.63,4.5 -4.66,0.93 -1.5,2.73 -3.58,-2.04 -6.6,1.34 c -0.43,0.09 -0.87,0.13 -1.31,0.13 -0.89,0 -1.79,-0.18 -2.64,-0.53 l -4.29,-1.76 c -0.2,-0.08 -0.41,-0.16 -0.62,-0.22 l -6.76,-1.98 c -0.72,-0.21 -1.38,-0.63 -1.88,-1.2 l -2.65,-3 -5.31,-5.13 4.67,-8.54 -0.59,-5.5 2.28,-1.22 c 0.28,-0.15 0.6,-0.23 0.92,-0.23 0.36,0 0.72,0.09 1.06,0.28 l 2.44,1.39 5.29,-2.93 2.48,-2.35 1.35,-0.11 1.82,-3.33 c 1.58,-1.22 3.47,-1.63 5.33,-1.63 m 0,-2.46 c -2.69,0 -4.99,0.72 -6.83,2.15 l -0.41,0.32 -0.25,0.45 -1.18,2.16 h -0.02 c 0,0 -0.87,0.07 -0.87,0.07 l -0.63,0.6 -2.26,2.13 -3.81,2.11 -1.24,-0.7 c -0.7,-0.4 -1.48,-0.61 -2.28,-0.61 -0.73,0 -1.44,0.18 -2.08,0.51 l -2.28,1.22 -1.47,0.78 0.18,1.66 0.51,4.73 -4.3,7.86 -0.9,1.65 1.35,1.31 5.24,5.06 2.58,2.93 c 0.81,0.92 1.86,1.59 3.04,1.93 l 6.76,1.98 c 0.13,0.04 0.26,0.08 0.38,0.13 l 4.29,1.76 c 1.15,0.47 2.35,0.71 3.58,0.71 0.61,0 1.21,-0.06 1.8,-0.18 l 5.7,-1.15 2.78,1.59 2.18,1.24 1.2,-2.2 0.94,-1.73 3.53,-0.71 1.36,-0.27 0.47,-1.3 1.17,-3.23 6.37,-1.44 1.08,-0.25 0.53,-0.97 1.93,-3.53 0.68,-1.24 -0.73,-1.21 -1.93,-3.19 2.35,-4.29 1.32,-2.42 -2.55,-1.04 -3.87,-1.58 -1.67,-4.83 -0.34,-1 -0.96,-0.44 -11.69,-5.36 c -0.52,-0.25 -4.49,-2.14 -8.78,-2.14 v 0 z",
    id: "path118"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(-15.376836,-22.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m 459.26,109.52 2.19,-11.62 -9.41,-5.99 -11.48,6.06 c 0,0 -10.24,13.75 -8.72,23.16 1.52,9.41 -4.22,17.72 -4.22,17.72 l 5.73,0.79 c 0,0 -5.7,18.33 -5.77,23.59 0,0 6.9,16.03 6.36,20.92 l 11.28,5 2.26,-4.68 c 0,0 -8.09,-5.82 -8.13,-7.54 -0.04,-1.72 4.09,-2.41 4.09,-2.41 l 1.25,1.08 19.03,-13.78 2.13,3.61 3.68,-1.44 -0.46,-11.96 -8.25,-1.75 -0.93,4.23 -10.38,4.61 -0.69,-16.2 6.9,2.46 7.46,-10.79 c 0,0 2,-5.94 0.36,-14.72 l -4.28,-10.36 z",
    id: "path122"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "422.09,135.15 425.78,129.59 425.24,127.17 420.6,129.62 415.73,129.09 415.1,131.47 420.25,132.89 ",
    id: "polygon124"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(-15.376836,-22.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "294.31,119.27 298.73,111.45 309.58,113.12 314.28,121.18 306.23,128.77 301.81,128.09 ",
    id: "polygon128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m 299.38,112.79 4.72,0.73 4.72,0.73 3.91,6.71 -6.9,6.5 -3.37,-0.52 -6.65,-7.81 3.58,-6.34 m -1.31,-2.69 -0.84,1.48 -3.58,6.34 -0.85,1.5 1.12,1.31 6.65,7.81 0.59,0.7 0.91,0.14 3.37,0.52 1.19,0.18 0.88,-0.83 6.9,-6.5 1.42,-1.34 -0.98,-1.69 -3.91,-6.71 -0.59,-1.02 -1.16,-0.18 -4.72,-0.73 -4.72,-0.73 -1.68,-0.26 v 0 z",
    id: "path130"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g138"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "313.62,73.62 317.44,78.88 314.22,80.06 310.67,77.37 ",
    id: "polygon134"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m 313.58,75.66 1.91,2.63 -1.06,0.39 -2.02,-1.53 1.17,-1.49 m 0.08,-4.08 -2.01,2.56 -1.17,1.49 -1.55,1.97 2,1.52 2.02,1.53 1.08,0.82 1.27,-0.47 1.06,-0.39 3.06,-1.13 -1.92,-2.64 -1.91,-2.63 -1.92,-2.63 v 0 z",
    id: "path136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "255.03,130.15 260.28,130.96 252.79,144.19 248.63,143.55 ",
    id: "polygon140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m 255.74,131.51 2.58,0.4 -6.19,10.93 -1.68,-0.26 5.29,-11.07 m -1.43,-2.71 -0.79,1.65 -5.29,11.07 -1.43,2.99 3.28,0.5 1.68,0.26 1.68,0.26 0.84,-1.48 6.19,-10.93 1.76,-3.11 -3.53,-0.54 -2.58,-0.4 -1.81,-0.28 v 0 z",
    id: "path142"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m 254.5,110.21 0.42,-0.79 c 0.66,-1.25 2.06,-4.45 0.68,-7.08 -0.31,-0.59 -0.85,-1.15 -1.93,-2.26 -1.72,-1.77 -3.33,-3.43 -5.27,-3.67 -0.13,-0.02 -0.24,-0.02 -0.34,-0.02 -0.2,0 -0.31,0.03 -0.54,0.1 -0.38,0.11 -0.9,0.25 -1.82,0.25 h -0.16 c -1.14,-0.02 -4.06,-0.28 -6.49,-2.28 -3.49,-2.86 -3.54,-7.2 -3.51,-8.2 -0.07,-1.63 0.36,-2.84 1.27,-3.6 0.67,-0.56 1.34,-0.66 1.89,-0.74 0.1,-0.02 0.21,-0.03 0.32,-0.05 0.81,-0.15 1.17,-0.46 1.82,-1.03 0.51,-0.45 1.16,-1.01 2.16,-1.59 0.89,-0.52 2.75,-1.59 4.43,-1.59 0.67,0 1.27,0.17 1.76,0.5 0.93,0.62 1.23,1.78 1.79,3.91 0.25,0.95 0.37,1.58 0.46,2.04 0.12,0.62 0.13,0.63 0.19,0.7 0.29,0.31 0.98,0.65 1.83,0.65 0.62,0 1.18,-0.18 1.57,-0.52 0.86,-0.74 0.72,-2.03 0.7,-2.18 l -0.16,-1.21 8.91,-1.22 -0.03,-2.47 2.33,-2.9 -0.27,-0.86 -4.71,-0.72 -0.28,-0.58 c -0.93,-1.9 -1.62,-3.89 -2.06,-5.91 -0.45,-2.07 -0.63,-4.18 -0.55,-6.27 -3.6,-0.21 -4.57,-0.61 -4.74,-1.74 -0.16,-1.09 0.88,-1.52 1.27,-1.68 0.37,-0.15 0.79,-0.32 1.1,-0.67 0.34,-0.38 0.35,-0.72 0.34,-1.46 0,-0.68 -0.02,-1.52 0.46,-2.38 0.89,-1.62 3,-2.48 6.1,-2.48 2.01,0 4.3,0.37 6.28,1.03 1.63,0.54 2.77,1.18 4.35,2.06 2.48,1.39 4.82,3.03 6.97,4.88 l 16.45,2.18 -0.15,1.59 3.26,0.59 4.46,5.56 5.41,0.83 -1.87,1.73 c -1.24,1.15 -2.21,2.53 -2.88,4.09 -0.64,1.51 -0.97,3.12 -0.98,4.8 v 1.43 c 0,0 -4.22,-0.65 -4.22,-0.65 l -6,5.31 -9.32,-1.68 -0.26,-0.22 c -1.32,-1.15 -2.77,-2.11 -4.33,-2.86 -2.54,-1.22 -5.29,-1.84 -8.15,-1.84 -0.19,0 -0.38,0 -0.55,0 l -0.8,2.87 c 0.88,1.04 1.66,2.16 2.32,3.33 1.1,1.96 1.88,4.07 2.3,6.26 l 0.1,0.5 -0.29,0.42 c -2.11,3.11 -3.92,6.35 -5.41,9.63 -0.8,1.77 -1.2,2.65 -1.43,3.48 -0.55,1.94 -0.6,3.53 -0.66,5.05 -0.07,2.02 -0.14,3.93 -1.44,5.88 -0.61,0.92 -1.4,1.71 -2.35,2.36 l -0.86,0.59 -8.9,-9.22 z",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m 263.44,51.44 c 1.95,0 4.11,0.38 5.9,0.97 1.52,0.5 2.59,1.1 4.14,1.97 3.14,1.76 5.49,3.62 7.04,4.97 l 15.64,2.08 c -0.05,0.51 -0.1,1.02 -0.15,1.53 1.31,0.24 2.61,0.48 3.92,0.71 1.49,1.86 2.98,3.72 4.47,5.58 1.12,0.17 2.25,0.35 3.37,0.52 -0.87,0.81 -2.22,2.27 -3.17,4.51 -0.91,2.14 -1.07,4.08 -1.08,5.28 -1.12,-0.17 -2.25,-0.35 -3.37,-0.52 -1.99,1.77 -3.99,3.53 -5.98,5.3 -2.8,-0.51 -5.6,-1.01 -8.4,-1.52 -1.11,-0.97 -2.63,-2.1 -4.61,-3.04 -3.37,-1.62 -6.52,-1.96 -8.68,-1.96 -0.58,0 -1.08,0.02 -1.5,0.06 -0.41,1.46 -0.81,2.91 -1.22,4.37 0.82,0.9 1.76,2.11 2.61,3.62 1.29,2.29 1.88,4.4 2.16,5.89 -2.66,3.92 -4.4,7.34 -5.51,9.82 -0.83,1.83 -1.24,2.75 -1.49,3.66 -1.33,4.74 0.04,7.61 -1.94,10.59 -0.7,1.04 -1.53,1.69 -2.02,2.02 -2.52,-2.61 -5.04,-5.22 -7.56,-7.83 0.57,-1.07 2.43,-4.9 0.68,-8.23 -0.39,-0.75 -0.98,-1.35 -2.15,-2.55 -1.86,-1.91 -3.63,-3.73 -5.99,-4.03 -0.19,-0.02 -0.35,-0.03 -0.49,-0.03 -0.83,0 -1.02,0.35 -2.37,0.35 -0.04,0 -0.09,0 -0.14,0 -0.86,-0.01 -3.53,-0.19 -5.73,-1.99 -3.2,-2.62 -3.08,-6.79 -3.06,-7.25 -0.04,-0.88 0.05,-2.01 0.83,-2.65 0.51,-0.42 1.03,-0.41 1.65,-0.52 1.94,-0.36 2.18,-1.5 4.37,-2.77 0.78,-0.45 2.46,-1.43 3.82,-1.43 0.4,0 0.77,0.08 1.08,0.29 0.53,0.35 0.79,1.3 1.29,3.2 0.62,2.33 0.43,2.7 0.94,3.25 0.59,0.64 1.65,1.05 2.74,1.05 0.84,0 1.7,-0.25 2.37,-0.82 1.36,-1.17 1.14,-3.05 1.11,-3.27 2.93,-0.4 5.85,-0.8 8.78,-1.2 -0.01,-1.04 -0.03,-2.08 -0.04,-3.12 0.82,-1.02 1.64,-2.04 2.46,-3.06 -0.23,-0.74 -0.46,-1.48 -0.7,-2.22 -1.61,-0.25 -3.22,-0.5 -4.83,-0.74 -0.7,-1.43 -1.46,-3.33 -1.96,-5.63 -0.63,-2.92 -0.61,-5.42 -0.44,-7.18 -3.98,-0.17 -4.79,-0.49 -4.83,-0.74 -0.05,-0.33 1.19,-0.37 2.07,-1.35 1.2,-1.34 0.24,-2.75 0.96,-4.07 0.72,-1.32 2.72,-1.84 5.02,-1.84 m 0,-2.46 c -4.52,0 -6.4,1.7 -7.18,3.12 -0.63,1.14 -0.62,2.25 -0.61,2.99 0,0.21 0,0.53 -0.02,0.63 -0.13,0.14 -0.4,0.24 -0.66,0.35 -2.01,0.82 -2.13,2.23 -2.02,2.99 0.29,1.98 2.13,2.51 4.7,2.72 0.01,1.8 0.21,3.59 0.6,5.37 0.46,2.12 1.19,4.21 2.15,6.19 l 0.57,1.16 1.27,0.2 2.13,0.33 0.68,0.11 -0.07,0.08 -1.23,1.53 -0.55,0.69 v 0.88 c 0,0 0.02,0.94 0.02,0.94 l -1.95,0.27 -4.67,0.64 -2.43,0.33 0.32,2.43 c 0.02,0.15 0.03,0.82 -0.28,1.09 -0.16,0.14 -0.44,0.22 -0.76,0.22 -0.34,0 -0.62,-0.09 -0.78,-0.17 -0.01,-0.06 -0.02,-0.12 -0.03,-0.18 -0.09,-0.45 -0.22,-1.13 -0.48,-2.12 -0.62,-2.33 -0.99,-3.74 -2.3,-4.62 -0.7,-0.47 -1.53,-0.71 -2.45,-0.71 -2.02,0 -4.07,1.19 -5.05,1.76 -1.11,0.64 -1.83,1.27 -2.35,1.73 -0.63,0.55 -0.77,0.66 -1.23,0.75 -0.1,0.02 -0.19,0.03 -0.28,0.04 -0.58,0.09 -1.56,0.23 -2.49,1.01 -0.84,0.7 -1.81,2.05 -1.72,4.55 -0.04,1.21 0.09,5.97 3.96,9.14 2.73,2.24 5.98,2.53 7.25,2.55 h 0.18 c 1.01,0 1.62,-0.15 2.16,-0.3 0.06,-0.02 0.12,-0.04 0.19,-0.05 0.06,0 0.12,0 0.19,0.01 1.51,0.19 2.91,1.63 4.53,3.31 1.07,1.1 1.51,1.56 1.73,1.98 1.1,2.1 -0.11,4.85 -0.68,5.93 l -0.84,1.58 1.24,1.29 3.78,3.91 3.78,3.91 1.44,1.5 1.72,-1.17 c 1.08,-0.74 1.98,-1.64 2.68,-2.69 1.5,-2.25 1.57,-4.42 1.65,-6.52 0.05,-1.46 0.11,-2.96 0.61,-4.77 0.21,-0.73 0.59,-1.6 1.37,-3.31 1.45,-3.22 3.24,-6.4 5.3,-9.45 l 0.57,-0.85 -0.19,-1 c -0.45,-2.32 -1.27,-4.55 -2.44,-6.63 -0.59,-1.05 -1.27,-2.06 -2.03,-3.01 l 0.38,-1.36 c 2.54,0.05 4.97,0.63 7.24,1.71 1.45,0.7 2.81,1.6 4.05,2.67 l 0.51,0.45 0.67,0.12 3.17,0.57 5.23,0.94 1.18,0.21 0.89,-0.79 3.65,-3.23 1.47,-1.3 0.54,0.08 1.68,0.26 2.82,0.43 0.02,-2.86 c 0,-1.51 0.31,-2.97 0.88,-4.32 0.6,-1.4 1.46,-2.63 2.58,-3.67 l 3.74,-3.47 -5.04,-0.78 -1.31,-0.2 -1.11,-0.17 -2.57,-3.2 -1.31,-1.63 -0.58,-0.72 -0.9,-0.16 -1.66,-0.3 h -0.03 c 0,0 0.16,-1.65 0.16,-1.65 l -2.36,-0.31 -14.91,-1.98 c -2.13,-1.8 -4.45,-3.41 -6.88,-4.77 -1.58,-0.89 -2.82,-1.58 -4.57,-2.16 -2.1,-0.69 -4.53,-1.09 -6.67,-1.09 v 0 z",
    id: "path148"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCorailHome);
export default __webpack_public_path__ + "static/media/illustration_corail_home.f8c0d9d3c1f1e412e194b9daf6404c33.svg";
export { ForwardRef as ReactComponent };